export default "__VITE_ASSET__ClOCnirL__"